import { format } from "date-fns";
import api from "../services/api";

interface IPrevisionResponse {
    codeResult: string;
    data: any[];
}

export interface IPrevisionParams {
    year: string;
    month: string;
    status: string;

}
export interface IPrevision {
    quantidade: number;
    representante: string;
}


class PrevisionRepository {
    public async PartialMonth({ year, month, status }: IPrevisionParams): Promise<IPrevision[]> {
        const initialDate = format(new Date(parseInt(year), parseInt(month) - 1, 14, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");
        const endDate = format(new Date(parseInt(year), parseInt(month) - 1, 16, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");

        const body = {
            "tables": ["Kit", "Pedido", "GerenteRegional", "GerenteSetor", "Representante"],
            "sql": [
                {
                    "coderesult": "Previsao",
                    "query": `SELECT Representante.nome as Representante, 
                    COUNT(Kit.id) as Qtd
                    FROM Kit 
                    INNER JOIN Pedido 
                    ON Pedido.id = Kit.pedidoId 
                    INNER JOIN Representante 
                    ON Representante.id = Pedido.representanteId
                    WHERE Kit.statusKit IN(${status}) 
                    AND Pedido.acerto >= '${initialDate}' 
                    AND Pedido.acerto <= '${endDate}' 
                    GROUP BY Representante.nome 
                    ORDER BY Representante`
                }
            ]
        };

        const response = await api.post<IPrevisionResponse[]>("reports", body);
        console.log(response);
        return this.GetFromCodeResult(response.data, "Previsao").map(result => {
            return {
                quantidade: result.Qtd,
                representante: result.Representante
            }
        });
    }

    GetFromCodeResult(data: IPrevisionResponse[], codeResult: string) {

        return data.find(result => result.codeResult === codeResult)?.data || [];
    }
}

const previsionRepository = new PrevisionRepository();
export default previsionRepository;